import React, { useEffect, useState } from "react";
import { Box, Button, Container, Stack, TextField } from "@mui/material";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Terms = () => {
	const { t } = useTranslation();

	return (
		<Container>

			<h1 style={{ fontWeight: "bold", marginTop: "80px" }}>{t("terms.title")}</h1>
			<h2>{t("terms.t1")}</h2>
			<p>{t("terms.p1")} </p>
			<h2>{t("terms.t2")}</h2>
			<p>{t("terms.p2")}</p>
			<h2>{t("terms.t3")}</h2>
			<p>{t("terms.p3")}</p>
			<h2>{t("terms.t4")}</h2>
			<p>{t("terms.p4")}</p>
			<h2>{t("terms.t5")}</h2>
			<p>{t("terms.p5")}</p>

		</Container>

	)


};
